export default __webpack_public_path__ + "static/media/43.f6e5d93c.jpg";